<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İlk Ödeme Tarihi</label>
            <v-validator :errors="errors" parameter="FirstPaymentDate" :watch="value.FirstPaymentDate">
                <v-date-picker v-model="value.FirstPaymentDate" placeholder="İlk Ödeme Tarihi"></v-date-picker>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İşe Başlangıç Günü/ 2. İşe Başlangıç Günü</label>
            <v-validator :errors="errors" parameter="SecondJobStartDay" :watch="range">
                <vue-slider v-model="range" :min="1" :max="31" :min-range="1" tooltip-placement="bottom" class="my-50"></vue-slider>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Periyot</label>
            <v-validator :errors="errors" parameter="Period" :watch="value.Period">
                <b-form-spinbutton min="0" v-model="value.Period"></b-form-spinbutton>
            </v-validator>
        </div>
        <div class="col-md-6 mb-1 mb-md-0">
            <label class="form-label">Periyot Sıklığı</label>
            <v-validator :errors="errors" parameter="Monthly" :watch="value.Monthly">
                <select class="form-control" v-model="value.Monthly">
                    <option :value="true">Ayda Bir</option>
                    <option :value="false">Günde Bir</option>
                </select>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Eksik Gün Toleransı</label>
            <v-validator :errors="errors" parameter="LackOfDayTolerance" :watch="value.LackOfDayTolerance">
                <b-form-spinbutton min="0" max="31" v-model="value.LackOfDayTolerance"></b-form-spinbutton>
            </v-validator>
        </div>
        <div class="col-12">
            <hr/>  
            <h5 class="font-weight-bolder mb-1 px-1">İşe giriş tarihi, ayın;</h5>
            <div class="row">
                <div class="col-lg-4 mb-1 mb-lg-0">
                    <div class="alert alert-dark mb-0">
                        <div class="alert-body p-1">
                            <h6 class="font-weight-bolder">
                                <template v-if="value.FirstJobStartDay">{{ value.FirstJobStartDay }}. gününden öncesinde</template>
                                <template v-else>İşe Giriş Günü Seçiniz</template>
                            </h6>
                            <hr/>
                            <div class="row">
                                <div class="col-12" :class="value.BJSFixedAmount ? 'mb-1':null">
                                    <label class="form-label">Tür</label>
                                    <v-validator :errors="errors" parameter="BJSFixedAmount" :watch="value.BJSFixedAmount">
                                        <select class="form-control" v-model="value.BJSFixedAmount" :disabled="value.FirstJobStartDay == null">
                                            <option :value="true">Sabit Kesinti</option>
                                            <option :value="false">Hakedilen Maaş</option>
                                        </select>
                                    </v-validator>
                                </div>
                                <div class="col-12" v-if="value.BJSFixedAmount">
                                    <label class="form-label">Tutar</label>
                                    <v-validator :errors="errors" parameter="BJSAmount" :watch="value.BJSAmount">
                                        <input class="form-control" type="number" :disabled="value.FirstJobStartDay == null" v-model="value.BJSAmount" placeholder="Ödenecek Tutar"/>
                                    </v-validator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-1 mb-lg-0">
                    <div class="alert alert-dark mb-0">
                        <div class="alert-body p-1">
                            <h6 class="font-weight-bolder">
                                <template v-if="value.SecondJobStartDay && value.FirstJobStartDay">{{ value.FirstJobStartDay }}. ve {{ value.SecondJobStartDay }}. günleri arasında</template>
                                <template v-else-if="value.FirstJobStartDay == null">İşe Giriş Günü Seçiniz</template>
                                <template v-else>2. İşe Başlangıç Günü Seçiniz</template>
                            </h6>
                            <hr/>
                            <div class="row">
                                <div class="col-12" :class="value.BFSFixedAmount ? 'mb-1':null">
                                    <label class="form-label">Tür</label>
                                    <v-validator :errors="errors" parameter="BFSFixedAmount" :watch="value.BFSFixedAmount">
                                        <select class="form-control" v-model="value.BFSFixedAmount" :disabled="value.FirstJobStartDay == null || value.SecondJobStartDay == null">
                                            <option :value="true">Sabit Kesinti</option>
                                            <option :value="false">Hakedilen Maaş</option>
                                        </select>
                                    </v-validator>
                                </div>
                                <div class="col-12" v-if="value.BFSFixedAmount">
                                    <label class="form-label">Tutar</label>
                                    <v-validator :errors="errors" parameter="BFSAmount" :watch="value.BFSAmount">
                                        <input class="form-control" type="number" v-model="value.BFSAmount" :disabled="value.FirstJobStartDay == null || value.SecondJobStartDay == null" placeholder="Ödenecek Tutar"/>
                                    </v-validator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="alert alert-dark mb-0">
                        <div class="alert-body p-1">
                            <h6 class="font-weight-bolder">
                                <template v-if="value.SecondJobStartDay">{{ value.SecondJobStartDay }}. gününden sonrasında</template>
                                <template v-else>2. İşe Başlangıç Günü Seçiniz</template>
                            </h6>
                            <hr/>
                            <div class="row">
                                <div class="col-12" :class="value.ASFixedAmount ? 'mb-1':null">
                                    <label class="form-label">Tür</label>
                                    <v-validator :errors="errors" parameter="ASFixedAmount" :watch="value.ASFixedAmount">
                                        <select class="form-control" v-model="value.ASFixedAmount" :disabled="value.SecondJobStartDay == null">
                                            <option :value="true">Sabit Kesinti</option>
                                            <option :value="false">Hakedilen Maaş</option>
                                        </select>
                                    </v-validator>
                                </div>
                                <div class="col-12" v-if="value.ASFixedAmount">
                                    <label class="form-label">Tutar</label>
                                    <v-validator :errors="errors" parameter="ASAmount" :watch="value.ASAmount">
                                        <input class="form-control" type="number" :disabled="value.SecondJobStartDay == null" v-model="value.ASAmount" placeholder="Ödenecek Tutar"/>
                                    </v-validator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { BFormSpinbutton } from 'bootstrap-vue'
import VueSlider from 'vue-slider-component'

export default {
    components:{
        BFormSpinbutton,
        VueSlider
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            days:Array.from(Array(31).keys()).map(i=>i+1),
        }
    },
    computed:{
        range:{
            get:function(){
                return [this.value.FirstJobStartDay,this.value.SecondJobStartDay]
            },
            set:function(value){
                this.value.FirstJobStartDay = value[0]
                this.value.SecondJobStartDay = value[1]
            }
        },
    }
}
</script>

<style lang="scss">
$themeColor: #1F4690;

@import '~vue-slider-component/lib/theme/default.scss';
</style>